import { render, staticRenderFns } from "./TrainPadLog.vue?vue&type=template&id=dc846b36&scoped=true&"
import script from "./TrainPadLog.vue?vue&type=script&lang=js&"
export * from "./TrainPadLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc846b36",
  null
  
)

export default component.exports